export enum BRAND_UI_TYPES {
    SELECTED,
    AVAILABLE,
    DEFAULT,
}
